import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireComment} from '@tisa-group/models';
import {Observable} from 'rxjs';

import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class CommentsService implements CrudService<UmpireComment> {
  constructor(readonly http: TisaUmpireHttpService) {}

  update(
    body: Partial<UmpireComment>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireComment>> {
    return this.http
      .patch(`/comments/${body?.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireComment[]>> {
    return this.http
      .get(`/comments`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
